import { render, staticRenderFns } from "./InfoLink.vue?vue&type=template&id=f1dd7440"
import script from "./InfoLink.vue?vue&type=script&lang=js"
export * from "./InfoLink.vue?vue&type=script&lang=js"
import style0 from "./InfoLink.vue?vue&type=style&index=0&id=f1dd7440&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports